import styled from 'styled-components/macro';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FaqTitle = styled.div`
  font-size: 18px;
  font-family: PingFangSC-SemiBold, PingFang SC;
  font-weight: 600;
  color: #11202B;
  line-height: 25px;
  text-align: center;
  margin-top: 25px;
`;

export const FaqEnTitle = styled.span`
  font-size: 18px;
  font-family: Squad-Bold, Squad;
  color: #11202B;
  line-height: 25px;
  text-align: center;
  margin-top: 25px;
`;

export const FaqContent = styled.div`
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #11202B;
  font-weight: 600;
  line-height: 21px;
  margin-top: 10px;
  opacity: 0.5;
`;

export const FaqEnContent = styled.span`
  font-size: 14px;
  font-family: Squad-Bold, Squad;
  color: #11202B;
  line-height: 21px;
  margin-top: 10px;
`;

export const SplitLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: #11202B;
  opacity: 0.05;
  margin-top: 20px;
`;
